import { createContext, useContext, useState, useCallback } from "react";

const STRINGS = {
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.howItWorks": "How It Works",
    "nav.pricingQuote": "Pricing & Quote",
    "nav.faq": "FAQ",
    "nav.blog": "Blog",
    "nav.getQuote": "Get a Quote",
    "nav.merida": "Mérida",
    "nav.startHere": "Start Here",
    "nav.yourRoute": "Your Route",
    "nav.costCalculator": "Cost Calculator",
    "nav.guides": "Guides",
    "nav.contact": "Contact",
    "nav.book": "Book a call",
    "footer.company": "Company",
    "footer.clientLogin": "Client login",
    "footer.about": "About us",
    "footer.services": "Services",
    "footer.guides": "All guides",
    "footer.blurb": "Calm, clear guidance for your move from the US to Mexico. Planning, coordination, and support — every step of the way.",
    "footer.explore": "Explore",
    "footer.getInTouch": "Get in touch",
    "footer.contactUs": "Contact us",
    "footer.bookCall": "Book an intro call",
    "footer.meridaHome": "Mérida (home base)",
    "footer.startHere": "Start Here",
    "footer.exploreMexico": "Explore Mexico",
    "footer.yourRoute": "Your Route",
    "footer.blog": "Resources & Blog",
    "footer.costCalculator": "Cost Calculator",
    "footer.pets": "Moving with Pets",
    "footer.emailGeneral": "General questions, inquiries & quotes",
    "footer.emailSupport": "Problems & support",
    "footer.privacy": "Privacy Notice",
    "wa.chat": "Chat on WhatsApp",
    "wa.prefillGeneral": "Hola! I have a question about moving to Mexico.",
    "book.eyebrow": "Book a Video Consultation",
    "book.title": "Let's plan your move — together.",
    "book.video": "In-site video call (no downloads)",
    "book.minutes": "minutes",
    "book.step1": "1 · Choose an appointment",
    "book.step2": "2 · Pick a date & time",
    "book.step3": "3 · Your details",
    "book.name": "Name",
    "book.email": "Email",
    "book.phone": "Phone",
    "book.moveDate": "Preferred move date",
    "book.notes": "Anything you'd like us to know? (optional)",
    "book.free": "Free",
    "book.deposit": "deposit",
    "book.mostPopular": "Most popular",
    "book.noTimes": "No times are currently available. Please check back soon or use the contact form.",
    "book.continueDeposit": "Continue to deposit",
    "book.requestBtn": "Request appointment",
    "book.submitting": "Submitting…",
    "book.howItWorks": "How it works",
    "book.selection": "Your selection",
    "book.noDeposit": "No deposit required",
    "book.reqTitle": "Request & approve",
    "book.reqBody": "Your time is held while we review. You'll get an email confirmation with a private, in-site video link once approved. Your deposit goes toward your consultation — no surprises.",
    "book.receivedTitle": "Request received!",
    "book.backHome": "Back home",
    "common.clientSignIn": "Client Sign In",
    "common.signInShort": "Sign In",
    "common.myPortal": "My Portal",
    "portal.tripPhotosTitle": "My Trip Photos",
    "portal.tripPhotosIntro": "Share photos and videos from your move. They stay private unless you choose to let us show them.",
    "portal.tripUpload": "Upload a photo or video",
    "portal.tripLimits": "Up to 30 photos and 5 videos, up to 100MB each.",
    "portal.tripCaption": "Caption (optional)",
    "portal.consentWebsite": "Hola Movers may show this on its website.",
    "portal.consentSocial": "Hola Movers may share this on its social media.",
    "portal.consentAttestation": "I took this photo or have permission to share it, and everyone shown agrees to it being shared. I can remove it or change my answer anytime.",
    "portal.tripEmpty": "No photos or videos yet.",
    "portal.statusPrivate": "Private",
    "portal.statusPending": "Waiting for approval",
    "portal.statusApproved": "Shown on website",
    "portal.statusRejected": "Not approved",
    "portal.statusHidden": "Hidden",
    "portal.tripDelete": "Delete",
    "portal.tripDeleteConfirm": "Delete this? If it's shown on the website, it will be removed immediately.",
    "portal.tripUploaded": "Uploaded",
    "portal.tripDeleted": "Deleted",
    "portal.tripLoadVideo": "Load video",
    "reviews.clientPhotosTitle": "Client Photos",
    "reviews.clientPhotosFamily": "A Hola Movers family",
    "home.readReviews": "Read reviews",
    "home.fiveStarsAria": "5 out of 5 stars",
    "home.meetNicoTitle": "Meet Nico",
    "home.meetNicoText": "Nico — part dachshund, part chihuahua — was our very first passenger, riding from San Antonio to Mérida with his blanket, his toys, and his best friend Mario.",
    "home.readNicoStory": "Read Nico's story",
    "home.testimonialsTitle": "What Our Clients Say",
    "home.ownerReviewTitle": "I Couldn't Have Picked a Better Person to Move My Nico",
    "home.ownerReviewBody": `Relocating from San Antonio to Mérida was a big change, and my biggest worry wasn't the drive. It was Nico. He's my little dachshund-chihuahua mix, and he's family. Handing him over for a long international trip felt huge.

I could not have picked a better person than Jocelyn to move my Nico. She paid close attention to him the whole way. When the others went to eat, she stayed behind with Nico. She said it gave her bonding time with him, and that tells you everything about who she is.

A team member brought Jocelyn back a meal, and she shared a little bit of chicken with Nico so he would take his medicine. She made sure it was plain, with no sauces or seasoning, so it wouldn't upset his tummy. That's the kind of detail you can't train into someone. It comes from truly caring about animals.

Nico had his own comfortable crate with his blanket for naps, his favorite toys, and Mario, the stuffed toy he can't live without. They packed his favorite food so his routine stayed the same. He got frequent walks, dinner at every stop, and treats along the way.

Four days after arriving in Mérida, Nico saw a vet and got a clean bill of health. He arrived healthy, relaxed, and still wagging.

If you're relocating between the US and Mexico with pets, people, or both, choose Hola Movers. They treat your family like their own, right down to the medicine and the plain chicken. I'd book them again without a second thought.

Five stars, and two paws up from Nico.`,
    "home.ownerReviewAttribution": "Nico's Family, Mérida, Mexico",
    "nico.metaTitle": "Nico's Story: Our First Passenger",
    "nico.metaDesc": "Nico's trip, in his own words.",
    "nico.intro": "Nico's trip, in his own words.",
    "nico.readFamily": "Read what Nico's family had to say",
    "nico.book": "Book a call",
    "nico.reviewTitle": "Two Paws Up: The Greatest Trip of My Life",
    "nico.reviewBody": `Hola, humans. My name is Nico. I'm part dachshund, part chihuahua (we think), and all heart. I'm proud to be Hola Movers' very first client.

I went all the way from San Antonio, Texas, to Mérida, Mexico. I was a little nervous at first, but then I saw my private cabin. (My humans call it a crate, but trust me, it was a cabin.) It had my favorite blanket for naps, my toys, and my best friend, Mario. Yes, they brought Mario. Nobody gets left behind with Hola Movers.

Jocelyn was with me the whole way, and she really, truly loves animals. I could tell right away. We stopped often for walks so I could stretch my little legs and smell new places. I had dinner every time we stopped, and I got treats along the way. My favorite food came along too, so every meal tasted like home.

Here's a secret: I had to take medicine on the trip. Yuck. But when the others went to eat, Jocelyn stayed with me so we could hang out. She called it our bonding time, and I agree. Then a team member, who never forgets that everyone should eat, brought her food. She shared some plain chicken with me. No sauce, nothing spicy, just right for my tummy. I didn't even notice the medicine. Best. Road. Snack. Ever.

When I got to Mérida, I saw a vet just four days later. The verdict: a clean bill of health. Healthy, happy, and a little bit famous.

I've only been on one trip in my whole life, and I give it an unprecedented two paws up. If you're a pet with a big trip coming up, tell your humans to call Hola Movers. You'll be treated like the VIP you are.

Woof (that means "five stars"),

Nico`,
  },
  es: {
    "nav.home": "Inicio",
    "nav.services": "Servicios",
    "nav.howItWorks": "Cómo funciona",
    "nav.pricingQuote": "Precios y cotización",
    "nav.faq": "Preguntas",
    "nav.blog": "Blog",
    "nav.getQuote": "Cotiza ahora",
    "nav.merida": "Mérida",
    "nav.startHere": "Empieza aquí",
    "nav.yourRoute": "Tu ruta",
    "nav.costCalculator": "Calculadora de costos",
    "nav.guides": "Guías",
    "nav.contact": "Contacto",
    "nav.book": "Agenda una llamada",
    "footer.company": "Empresa",
    "footer.clientLogin": "Acceso clientes",
    "footer.about": "Sobre nosotros",
    "footer.services": "Servicios",
    "footer.guides": "Todas las guías",
    "footer.blurb": "Orientación clara y tranquila para tu mudanza de EE. UU. a México. Planeación, coordinación y apoyo en cada paso.",
    "footer.explore": "Explorar",
    "footer.getInTouch": "Contáctanos",
    "footer.contactUs": "Contáctanos",
    "footer.bookCall": "Agenda una llamada",
    "footer.meridaHome": "Mérida (base)",
    "footer.startHere": "Empieza aquí",
    "footer.exploreMexico": "Explora México",
    "footer.yourRoute": "Tu ruta",
    "footer.blog": "Recursos y Blog",
    "footer.costCalculator": "Calculadora de costos",
    "footer.pets": "Mudarse con mascotas",
    "footer.emailGeneral": "Preguntas generales y cotizaciones",
    "footer.emailSupport": "Problemas y soporte",
    "footer.privacy": "Aviso de Privacidad",
    "wa.chat": "Escríbenos por WhatsApp",
    "wa.prefillGeneral": "Hola! Tengo una pregunta sobre mudarme a México.",
    "book.eyebrow": "Agenda una videoconsulta",
    "book.title": "Planeemos tu mudanza — juntos.",
    "book.video": "Videollamada en el sitio (sin descargas)",
    "book.minutes": "minutos",
    "book.step1": "1 · Elige una cita",
    "book.step2": "2 · Elige fecha y hora",
    "book.step3": "3 · Tus datos",
    "book.name": "Nombre",
    "book.email": "Correo electrónico",
    "book.phone": "Teléfono",
    "book.moveDate": "Fecha de mudanza preferida",
    "book.notes": "¿Algo que quieras contarnos? (opcional)",
    "book.free": "Gratis",
    "book.deposit": "de depósito",
    "book.mostPopular": "Más popular",
    "book.noTimes": "No hay horarios disponibles por ahora. Vuelve pronto o usa el formulario de contacto.",
    "book.continueDeposit": "Continuar al depósito",
    "book.requestBtn": "Solicitar cita",
    "book.submitting": "Enviando…",
    "book.howItWorks": "Cómo funciona",
    "book.selection": "Tu selección",
    "book.noDeposit": "Sin depósito requerido",
    "book.reqTitle": "Solicita y aprueba",
    "book.reqBody": "Reservamos tu horario mientras lo revisamos. Recibirás un correo de confirmación con un enlace de video privado en el sitio una vez aprobado. Tu depósito se aplica a tu consulta — sin sorpresas.",
    "book.receivedTitle": "¡Solicitud recibida!",
    "book.backHome": "Volver al inicio",
    "common.clientSignIn": "Acceso de clientes",
    "common.signInShort": "Acceso",
    "common.myPortal": "Mi portal",
    "portal.tripPhotosTitle": "Mis fotos del viaje",
    "portal.tripPhotosIntro": "Comparte fotos y videos de tu mudanza. Son privados a menos que elijas dejarnos mostrarlos.",
    "portal.tripUpload": "Sube una foto o video",
    "portal.tripLimits": "Hasta 30 fotos y 5 videos, máximo 100MB cada uno.",
    "portal.tripCaption": "Título (opcional)",
    "portal.consentWebsite": "Hola Movers puede mostrar esto en su sitio web.",
    "portal.consentSocial": "Hola Movers puede compartir esto en sus redes sociales.",
    "portal.consentAttestation": "Tomé esta foto o tengo permiso para compartirla, y todas las personas que aparecen están de acuerdo. Puedo eliminarla o cambiar mi respuesta en cualquier momento.",
    "portal.tripEmpty": "Aún no hay fotos ni videos.",
    "portal.statusPrivate": "Privado",
    "portal.statusPending": "Esperando aprobación",
    "portal.statusApproved": "En el sitio web",
    "portal.statusRejected": "No aprobado",
    "portal.statusHidden": "Oculto",
    "portal.tripDelete": "Eliminar",
    "portal.tripDeleteConfirm": "¿Eliminar esto? Si se muestra en el sitio web, se quitará de inmediato.",
    "portal.tripUploaded": "Subido",
    "portal.tripDeleted": "Eliminado",
    "portal.tripLoadVideo": "Cargar video",
    "reviews.clientPhotosTitle": "Fotos de clientes",
    "reviews.clientPhotosFamily": "Una familia de Hola Movers",
    "home.readReviews": "Leer opiniones",
    "home.fiveStarsAria": "5 de 5 estrellas",
    "home.meetNicoTitle": "Conoce a Nico",
    "home.meetNicoText": "Nico — mitad dachshund, mitad chihuahua — fue nuestro primer pasajero, viajando de San Antonio a Mérida con su cobija, sus juguetes y su mejor amigo Mario.",
    "home.readNicoStory": "Lee la historia de Nico",
    "home.testimonialsTitle": "Lo que dicen nuestros clientes",
    "home.ownerReviewTitle": "No podría haber elegido a una mejor persona para trasladar a mi Nico",
    "home.ownerReviewBody": `Irnos a vivir de San Antonio a Mérida fue un gran cambio, y mi mayor preocupación no era el viaje en carretera. Era Nico. Es una pequeña cruza de dachshund y chihuahua, y es parte de la familia. Dejarlo en manos de alguien para un viaje internacional tan largo no era poca cosa.

No podría haber elegido a una mejor persona que Jocelyn para trasladar a mi Nico. Estuvo muy atenta a él todo el camino. Cuando los demás fueron a comer, ella se quedó con Nico. Dijo que así tenía tiempo para convivir con él, y eso lo dice todo sobre quién es ella.

Alguien del equipo le trajo comida a Jocelyn, y ella compartió un poquito de pollo con Nico para que se tomara su medicina. Se aseguró de que fuera sencillo, sin salsas ni condimentos, para que no le cayera mal a su pancita. Ese tipo de detalle no se enseña. Nace de amar de verdad a los animales.

Nico tuvo su propia transportadora cómoda con su cobija para las siestas, sus juguetes favoritos y Mario, el peluche sin el que no puede vivir. Llevaron su comida favorita para que su rutina no cambiara. Tuvo caminatas frecuentes, cena en cada parada y premios en el camino.

Cuatro días después de llegar a Mérida, un veterinario revisó a Nico y confirmó que estaba completamente sano. Llegó sano, tranquilo y moviendo la colita.

Si vas a hacer tu traslado entre Estados Unidos y México con mascotas, personas o ambos, elige Hola Movers. Tratan a tu familia como si fuera suya, hasta en los detalles de la medicina y el pollo sencillo. Los volvería a contratar sin pensarlo dos veces.

Cinco estrellas, y dos patitas arriba de parte de Nico.`,
    "home.ownerReviewAttribution": "La familia de Nico, Mérida, México",
    "nico.metaTitle": "La historia de Nico: nuestro primer pasajero",
    "nico.metaDesc": "El viaje de Nico, en sus propias palabras.",
    "nico.intro": "El viaje de Nico, en sus propias palabras.",
    "nico.readFamily": "Lee lo que dijo la familia de Nico",
    "nico.book": "Agenda una llamada",
    "nico.reviewTitle": "Dos patitas arriba: el mejor viaje de mi vida",
    "nico.reviewBody": `Hola, humanos. Me llamo Nico. Soy mitad dachshund, mitad chihuahua (eso creemos) y todo corazón. Estoy orgulloso de ser el primer cliente de Hola Movers.

Viajé desde San Antonio, Texas, hasta Mérida, México. Al principio estaba un poco nervioso, pero luego vi mi cabina privada. (Mis humanos le dicen transportadora, pero créanme, era una cabina). Tenía mi cobija favorita para las siestas, mis juguetes y a mi mejor amigo, Mario. Sí, trajeron a Mario. Con Hola Movers, nadie se queda atrás.

Jocelyn estuvo conmigo todo el camino, y de verdad ama a los animales. Me di cuenta desde el principio. Parábamos seguido para caminar, estirar mis patitas y oler lugares nuevos. Cenaba en cada parada y me daban premios en el camino. También llevaron mi comida favorita, así que cada comida sabía a casa.

Les cuento un secreto: tuve que tomar medicina durante el viaje. Guácala. Pero cuando los demás fueron a comer, Jocelyn se quedó conmigo para hacerme compañía. Ella lo llamó nuestro tiempo para convivir, y estoy de acuerdo. Luego, alguien del equipo, que nunca olvida que todos deben comer, le trajo comida. Ella compartió conmigo un poco de pollo sencillo. Sin salsa, nada picante, perfecto para mi pancita. Ni noté la medicina. El. Mejor. Antojito. De. Carretera.

Cuando llegué a Mérida, me revisó un veterinario solo cuatro días después. El veredicto: completamente sano. Sano, feliz y un poquito famoso.

Solo he hecho un viaje en toda mi vida, y le doy dos patitas arriba, algo nunca antes visto. Si eres una mascota con un gran viaje en puerta, dile a tus humanos que llamen a Hola Movers. Te tratarán como el VIP que eres.

Guau (eso significa "cinco estrellas"),

Nico`,
  },
};

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("hm_lang") === "es" ? "es" : "en"; } catch { return "en"; }
  });
  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("hm_lang", l); } catch {}
  }, []);
  const t = useCallback((key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
